import React, { useState, useEffect } from 'react';

import {
    TITLE_IN_PRODUCTION,
    TITLE_IN_PRODUCTION_SMALL,
    TITLE_NOT_PRODUCTION,
    TITLE_NOT_PRODUCTION_SMALL
} from './constants';
import State from './components/State';
import { getEtapas } from '~services/EtapaService';

interface EtapaItem {
    stageName: string;
    showName: string;
    order: number;
}

interface Props {
    actualStageOrder: number;
    smallSize?: boolean;
    className?: string;
}

function ProjectState({actualStageOrder, smallSize, className}: Props) {
    const [stages, setStages] = useState<EtapaItem[] | null>(null);

    useEffect(() => {
        getEtapas().then((response: any) => {
            if (response.ok && response.data) {
                const etapas = response.data.map((e: any) => ({
                    stageName: e.name.toLowerCase(),
                    showName: e.name,
                    order: e.order
                }));
                setStages(etapas);
            }
        });
    }, []);

    if (!stages) {
        return null;
    }

    let finished = true;

    const stagesRender = stages.map((item, index) => {
       const inProduction = item.order === actualStageOrder;

        if (inProduction) {
            finished = false;
        }

        const {stageName} = item;

        const lineSizes = smallSize
            ? [TITLE_IN_PRODUCTION_SMALL, TITLE_NOT_PRODUCTION_SMALL]
            : [TITLE_IN_PRODUCTION, TITLE_NOT_PRODUCTION];

        const stage = {
            stageName,
            inProduction,
            finished,
            showName: item.showName,
            titleClassName: inProduction ? lineSizes[0] : lineSizes[1],
            first: index === 0,
            last: stages.length - index === 1
        };

        return <>
            <State key={`project_state_${stageName}`} stage={stage} smallSize={smallSize}/>
        </>;
    });

    return <div className={`row middle full-width ${className}`}>{stagesRender}</div>;
}

export default ProjectState;
